function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Component_303_1",
  "data-name": "Component 303 \\u2013 1",
  transform: "translate(0.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Union_4",
  "data-name": "Union 4",
  transform: "translate(36)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,12V4A4,4,0,0,1,4,0H17a4,4,0,0,1,4,4v8Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 20.00060081481934 10.99970054626465 L 20.00060081481934 3.999600172042847 C 20.00060081481934 2.345610380172729 18.65458106994629 1.000000238418579 17.00010108947754 1.000000238418579 L 3.999600410461426 1.000000238418579 C 2.345610380172729 1.000000238418579 1.000000357627869 2.345610380172729 1.000000357627869 3.999600172042847 L 1.000000357627869 10.99970054626465 L 20.00060081481934 10.99970054626465 M 21.00060081481934 11.99970054626465 L 4.07409658009783e-07 11.99970054626465 L 4.07409658009783e-07 3.999600172042847 C 4.07409658009783e-07 1.791000247001648 1.791000366210938 2.731323149873788e-07 3.999600410461426 2.731323149873788e-07 L 17.00010108947754 2.731323149873788e-07 C 19.2096004486084 2.731323149873788e-07 21.00060081481934 1.791000247001648 21.00060081481934 3.999600172042847 L 21.00060081481934 11.99970054626465 Z",
  stroke: "none",
  fill: "#707070"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_36",
  "data-name": "Ellipse 36",
  transform: "translate(19 9)",
  fill: "#f8f8f8",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 27,
  r: 27,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 27,
  r: 26.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_37",
  "data-name": "Ellipse 37",
  transform: "translate(38 28)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 7.5,
  r: 7.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 7.5,
  r: 7,
  fill: "none"
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_126",
  "data-name": "Line 126",
  y1: 6.246,
  x2: 6.246,
  transform: "translate(51.008 23.941)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_363",
  "data-name": "Rectangle 363",
  width: 14,
  height: 33,
  rx: 3,
  transform: "translate(19 19)",
  fill: "#f8f8f8"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_127",
  "data-name": "Line 127",
  x2: 25,
  transform: "translate(6 25)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_128",
  "data-name": "Line 128",
  x2: 31,
  transform: "translate(0 36)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_129",
  "data-name": "Line 129",
  x2: 25,
  transform: "translate(6 46)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_39",
  "data-name": "Ellipse 39",
  transform: "translate(41 31)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 4.5,
  r: 4.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 4.5,
  r: 4,
  fill: "none"
})));

function SvgQuick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.5,
    height: 63,
    viewBox: "0 0 73.5 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuick);
export default __webpack_public_path__ + "static/media/quick.9b677b1bcb976511833cefff6c540e5a.svg";
export { ForwardRef as ReactComponent };